import React, {useState} from 'react';
import {Button, Modal} from "antd";

const NotifyCreateRecordModal = ({
                                     showNotifyCreateRecordModal,
                                     setShowNotifyCreateRecordModal,
                                     modalText,
                                     modalTitle,
                                     redirectUrl,
                                 }) => {
    const [confirmLoading, setConfirmLoading] = useState(false);

    const handleOk = () => {
        setConfirmLoading(true);
        setTimeout(() => {
            setShowNotifyCreateRecordModal(false);
            setConfirmLoading(false);
            if (redirectUrl !== undefined && redirectUrl !== null) {
                window.location.href = redirectUrl;
            }
        }, 1000);
    };


    return (
        <Modal
            title={modalTitle}
            open={showNotifyCreateRecordModal}
            onOk={handleOk}
            confirmLoading={confirmLoading}
            footer={[
                <Button
                    key="ok"
                    type="primary"
                    onClick={handleOk}
                    loading={confirmLoading}
                >
                    Ok
                </Button>,
            ]}
        >
            <p className="text-lg text-blue-900">
                {modalText}
            </p>
        </Modal>
    );
};

export default NotifyCreateRecordModal;